import { MoreIcon } from '../Brand/Icon';
import React from "react";
import { Link } from 'react-router-dom';
import url from '../../utils/url';
import { createFeedStoryPreview } from '../../utils/feedStoryPreview';
import { opinionPath } from '../../utils/opinionPath';
import { useTranslation } from 'react-i18next';
import './index.scss';

/**
 * 
 * @param { number } scope - Оценка реакции
 * @param { string } msg_flg - Есть ли тектовый комментарий (1 - есть | 0 -нет)
 * @param { number } reactionId - Id реакции
 * @param { string } size - Размер прямоугольника
 * @param { string } source - Источник
 * @param { number } storyId - Id истории
 * @returns 
 */

export default function UserReactionScope({ scope = 0, msg_flg = '0', reactionId = 0, size = 'small', source = null, storyId = null, story, interactive = true, profileUsername, children }) {
	const { t } = useTranslation();
	const Element = interactive ? Link : 'span';
	return (
		<Element className={"story_user_scope scope" + scope + " size_" + size}
			aria-label={`${t('story.opinions')}: ${scope} / 7`}
			{...(interactive ? { to: url(opinionPath(reactionId, profileUsername)), state: {
				source, storyId, ...(story ? { feedStoryPreview: createFeedStoryPreview(reactionId, story) } : {}),
			} } : { role: 'img' })} >
			{children ?? <>
				{String(msg_flg) === '1' && <MoreIcon />}
				{size === 'big' && <span>wiw</span>}
			</>}
		</Element>
	)
};
